module.exports = __webpack_public_path__ + "media/images/Logo_Inecol31-f02716f9fcd34f5953ec012ed4e01850.jpg";